import { render, staticRenderFns } from "./shop-rec-v.vue?vue&type=template&id=7b60c4f5&scoped=true"
import script from "./shop-rec-v.vue?vue&type=script&lang=js"
export * from "./shop-rec-v.vue?vue&type=script&lang=js"
import style0 from "./shop-rec-v.vue?vue&type=style&index=0&id=7b60c4f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b60c4f5",
  null
  
)

export default component.exports